// extracted by mini-css-extract-plugin
module.exports = {"btnBox":"Buttons_btnBox__1kSwe","clickBtn":"Buttons_clickBtn__2BmwM"};